import { CanActivateFn } from '@angular/router';
import { AutentificacionService } from '../_services/autentificacion.service';
import { inject } from '@angular/core';
import { puedeEntrarAdministracion } from '../_helpers/utils';
import { SnackBarService } from '../_helpers/snack-bar.service';
import { NavController } from '@ionic/angular'

export const administracionGuard: CanActivateFn = (route, state) => {
  const authService = inject(AutentificacionService);
  const snackBarService = inject(SnackBarService);
  const navCtrl = inject(NavController);

  const usuario = authService.userInfo;
  if (puedeEntrarAdministracion(usuario.rol)) {
    return true
  }
  else {
    snackBarService.showError('Acceso denegado');
    navCtrl.navigateRoot('/')
    return false;
  }
};
